/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _ReactionButtonContainer_settings$ref: unique symbol;
export type ReactionButtonContainer_settings$ref = typeof _ReactionButtonContainer_settings$ref;
export type ReactionButtonContainer_settings = {
    readonly reaction: {
        readonly label: string;
        readonly labelActive: string;
        readonly icon: string;
        readonly iconActive: string | null;
    };
    readonly " $refType": ReactionButtonContainer_settings$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ReactionButtonContainer_settings",
    "type": "Settings",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "reaction",
            "storageKey": null,
            "args": null,
            "concreteType": "ReactionConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "label",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "labelActive",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "icon",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "iconActive",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '80fb77550d7dcc4ec52c04294ba100e0';
export default node;
